import { useMutation } from "urql";

import { UpdateClikResultDocument } from "../../../graphql/generated.ts";

export function useUpdateClikResult() {
  return useMutation(UpdateClikResultDocument);
}
